import { ROUTES } from '@/constants/routes';
import type { User, UserRole } from '@/types/auth.types';

type RoleUser = Pick<User, 'role' | 'isCompanyAdmin'>;

/**
 * ¿Puede el usuario acceder a un área protegida con estos roles permitidos?
 * Además del match directo por rol, un alumno con `isCompanyAdmin` ("alumno +
 * admin de empresa") puede entrar al área de empresa.
 */
export function canAccessArea(user: RoleUser, allowedRoles: UserRole[]): boolean {
  if (allowedRoles.includes(user.role)) return true;
  if (user.isCompanyAdmin && allowedRoles.includes('company_admin')) return true;
  return false;
}

/**
 * Ruta "home" del usuario tras login / al entrar por deep link. Para el usuario
 * dual (alumno + admin de empresa) depende del dispositivo (`prefersAdmin`): en
 * escritorio va al panel de empresa; en app/móvil, a la experiencia de alumno.
 */
export function getHomeRoute(user: RoleUser, prefersAdmin: boolean): string {
  switch (user.role) {
    case 'backoffice':
      return ROUTES.BACKOFFICE.DASHBOARD;
    case 'company_admin':
      return ROUTES.COMPANY.DASHBOARD;
    case 'student':
      return user.isCompanyAdmin && prefersAdmin
        ? ROUTES.COMPANY.DASHBOARD
        : ROUTES.STUDENT.DASHBOARD;
    default:
      return ROUTES.AUTH.LOGIN;
  }
}
